import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicyPage = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      
      <main style={{ 
        padding: '40px 20px', 
        maxWidth: '800px', 
        margin: '0 auto',
        flex: '1'
      }}>
        <h1 style={{ color: '#2c3e50', marginBottom: '30px' }}>Privacy Policy</h1>
        
        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>Data Protection Commitment</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            We will never sell your data. Your privacy and data security are our top priorities.
          </p>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>Data Usage</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            We may use de-identified user data to train our AI system to improve functionality and user experience. 
            This data is completely anonymized and cannot be traced back to individual users.
          </p>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>HIPAA Compliance</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            This service does not comply with HIPAA guidelines. We are not a HIPAA-covered entity. This service is for educational and entertainment purposes only. We do not maintain compliance
            with the Health Insurance Portability and Accountability Act (HIPAA).
          </p>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>Data Collection</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            We collect only the information necessary to provide our services. This includes:
          </p>
          <ul style={{ color: '#7f8c8d', lineHeight: '1.6', marginLeft: '20px' }}>
            <li>Basic account information</li>
            <li>Health-related information you choose to share</li>
            <li>Usage data to improve our services</li>
          </ul>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>Data Security</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            We implement industry-standard security measures to protect your data, including:
          </p>
          <ul style={{ color: '#7f8c8d', lineHeight: '1.6', marginLeft: '20px' }}>
            <li>Encryption of data in transit and at rest</li>
            <li>Regular security audits</li>
            <li>Access controls and authentication</li>
            <li>Secure data storage and backup procedures</li>
          </ul>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage; 